import { types, actions } from './requests'
export const GETWORKERLIST_TYPES = {
    ...types('GETWORKERLIST'),
}
export const GETWORKERLIST_ACTIONS = {
    ...actions('GETWORKERLIST'),
}
